// extracted by mini-css-extract-plugin
module.exports = {"explanationField":"CheckboxQuestionFormItem_explanationField__2UT0J"};